const _LANG = {
    en: {
        lang: "en",
        string: "English",
        code: "EN-US",
        flag: "flags-american",
    },
    ja: {
        lang: "ja",
        string: "日本語",
        code: "JA-JP",
        flag: "flags-japan",
    },
    zh: {
        lang: "zh",
        string: "中文(简体字)",
        code: "ZH-CN",
        flag: "flags-china",
    },
    "zh-tw": {
        lang: "zh-tw",
        string: "中文(繁體字)",
        code: "ZH-TW",
        flag: "flags-china",
    },
    ko: {
        lang: "ko",
        string: "한국어",
        code: "KO-KR",
        flag: "flags-korea",
    },
    ru: {
        lang: "ru",
        string: "русский язык",
        code: "RU-RU",
        flag: "flags-russia",
    },
    de: {
        lang: "de",
        string: "Deutsch",
        code: "DE-DE",
        flag: "flags-germany",
    },
    es: {
        lang: "es",
        string: "Español",
        code: "ES-US",
        flag: "flags-spain",
    },
    fr: {
        lang: "fr",
        string: "français",
        code: "FR-FR",
        flag: "flags-france",
    },
    it: {
        lang: "it",
        string: "italiano",
        code: "IT-IT",
        flag: "flags-italy",
    },
    pt: {
        lang: "pt",
        string: "Língua portuguesa",
        code: "PT-PT",
        flag: "flags-portugal",
    },
    th: {
        lang: "th",
        string: "ภาษาไทย",
        code: "TH-TH",
        flag: "flags-thailand",
    },
    sv: {
        lang: "sv",
        string: "svenska",
        code: "sv-se",
        flag: "flags-sweden",
    },
};
export const LANG = _LANG;
const _LOCALE = {
    "en-us": {
        region: "en-us",
        datetime: "en-us",
        string: "United States",
        firstDayOfWeek: "sun",
        nameSequence: "western",
        number: "comma-dot",
    },
    "ja-jp": {
        region: "ja-jp",
        datetime: "ja-jp",
        string: "Japan",
        firstDayOfWeek: "sun",
        nameSequence: "eastern",
        number: "comma-dot",
    },
    "zh-cn": {
        region: "zh-cn",
        datetime: "zh-cn",
        string: "China",
        firstDayOfWeek: "mon",
        nameSequence: "eastern",
        number: "comma-dot",
    },
    "zh-tw": {
        region: "zh-tw",
        datetime: "zh-tw",
        string: "Taiwan",
        firstDayOfWeek: "sun",
        nameSequence: "eastern",
        number: "comma-dot",
    },
    "ko-kr": {
        region: "ko-kr",
        datetime: "ko-kr",
        string: "Korea",
        firstDayOfWeek: "mon",
        nameSequence: "eastern",
        number: "comma-dot",
    },
    "ru-ru": {
        region: "ru-ru",
        datetime: "ru-ru",
        string: "Russia",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "space-comma",
    },
    "de-de": {
        region: "de-de",
        datetime: "de-de",
        string: "German",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "dot-comma",
    },
    "es-us": {
        region: "es-us",
        datetime: "es-us",
        string: "Spain",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "dot-comma",
    },
    "fr-fr": {
        region: "fr-fr",
        datetime: "fr-fr",
        string: "France",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "space-comma",
    },
    "it-it": {
        region: "it-it",
        datetime: "it-it",
        string: "Italy",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "dot-comma",
    },
    "en-gb": {
        region: "en-gb",
        datetime: "en-gb",
        string: "United Kingdom",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "comma-dot",
    },
    "pt-pt": {
        region: "pt-pt",
        datetime: "pt-pt",
        string: "Portugal",
        firstDayOfWeek: "sun",
        nameSequence: "western",
        number: "space-comma",
    },
    "th-th": {
        region: "th-th",
        datetime: "th-th",
        string: "Thailand",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "comma-dot",
    },
    "sv-se": {
        region: "sv-se",
        datetime: "sv-se",
        string: "Sweden",
        firstDayOfWeek: "mon",
        nameSequence: "western",
        number: "space-comma",
    },
};
export const LOCALE = _LOCALE;
const _DATE_TIME_OPTIONS = {
    "en-us": {
        key: "en-us",
        string: "United States",
    },
    "ja-jp": {
        key: "ja-jp",
        string: "Japan",
    },
    "zh-cn": {
        key: "zh-cn",
        string: "China",
    },
    "zh-tw": {
        key: "zh-tw",
        string: "Taiwan",
    },
    "ko-kr": {
        key: "ko-kr",
        string: "Korea",
    },
    "ru-ru": {
        key: "ru-ru",
        string: "Russia",
    },
    "de-de": {
        key: "de-de",
        string: "German",
    },
    "es-us": {
        key: "es-us",
        string: "Spain",
    },
    "fr-fr": {
        key: "fr-fr",
        string: "France",
    },
    "it-it": {
        key: "it-it",
        string: "Italy",
    },
    "en-gb": {
        key: "en-gb",
        string: "United Kingdom",
    },
    "pt-pt": {
        key: "pt-pt",
        string: "Portugal",
    },
    "th-th": {
        key: "th-th",
        string: "Thailand",
    },
    "sv-se": {
        key: "sv-se",
        string: "Sweden",
    },
};
export const DATE_TIME_OPTIONS = _DATE_TIME_OPTIONS;
const _NAME_OPTIONS = {
    western: {
        key: "western",
        string: "first last",
    },
    eastern: {
        key: "eastern",
        string: "last first",
    },
};
export const NAME_OPTIONS = _NAME_OPTIONS;
const _NUMBER_OPTIONS = {
    "comma-dot": {
        key: "comma-dot",
        localeID: "en-us",
        string: "123,456.0",
    },
    "space-comma": {
        key: "space-comma",
        localeID: "ru-ru",
        string: "123 456,0",
    },
    "dot-comma": {
        key: "dot-comma",
        localeID: "de-de",
        string: "123.456,0",
    },
};
export const NUMBER_OPTIONS = _NUMBER_OPTIONS;
